var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoInvoiceEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    fill: "#FF6019",
    fillOpacity: 0.16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.6668 50H50.0002M33.3335 60V33.3333C33.3335 32.4493 33.6847 31.6014 34.3098 30.9763C34.9349 30.3512 35.7828 30 36.6668 30H53.3335C54.2176 30 55.0654 30.3512 55.6905 30.9763C56.3156 31.6014 56.6668 32.4493 56.6668 33.3333V60L51.6668 56.6667L48.3335 60L45.0002 56.6667L41.6668 60L38.3335 56.6667L33.3335 60ZM40.0002 36.6667H50.0002H40.0002ZM40.0002 43.3333H50.0002H40.0002Z",
    stroke: "#FF6019",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoInvoiceEmpty);
export default __webpack_public_path__ + "static/media/roInvoiceEmpty.cca12e39.svg";
export { ForwardRef as ReactComponent };